import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { compose } from 'redux';
import injectSaga from 'utils/injectSaga';
import makeSelectAppointment from '../Appointment/selectors';
import { fetchLocationServices } from '../Appointment/actions';
import saga from '../Appointment/saga';

class MembershipPrices extends Component {
  constructor(props) {
    super(props);
    this.props = props;
  }
  componentDidMount() {
    const { selectedLocation, locationServices } = this.props.appointmentData;
    const { services } = locationServices;
    const { id } = selectedLocation;
    if (!services && id) {
      this.props.fetchLocationServices(id);
    }
  }
  render() {
    const { locationServices } = this.props.appointmentData;
    const main = {
      member_price: 0,
      non_member_price: 0,
    };
    const mid = {
      member_price: 0,
      non_member_price: 0,
    };
    const { services } = locationServices;
    if (services) {
      if (services.length > 0) {
        main.member_price = services[0].member_price;
        main.non_member_price = services[0].non_member_price;
        mid.member_price = services[1].member_price;
        mid.non_member_price = services[1].non_member_price;
      }
    }
    return (
      <div>
        <div className="memberPrice">
          80-Min Massage:{' '}
          <b>
            ${main.member_price} (${main.non_member_price} VALUE)
          </b>
        </div>
        <br />
        <div className="memberPrice">
          50-Min Massage:{' '}
          <b>
            ${mid.member_price} (${mid.non_member_price} VALUE)
          </b>
        </div>
        <br />
      </div>
    );
  }
}

const withSagaFetchLocationServices = injectSaga({
  key: 'fetchLocationServices',
  saga: saga.watchFetchLocationServices,
});

const mapStateToProps = createStructuredSelector({
  appointmentData: makeSelectAppointment(),
});

const withConnect = connect(
  mapStateToProps,
  {
    fetchLocationServices,
  },
);

MembershipPrices.propTypes = {
  appointmentData: PropTypes.object,
  fetchLocationServices: PropTypes.func,
};

export default compose(
  withConnect,
  withSagaFetchLocationServices,
)(MembershipPrices);
